import { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../components/styles/Stats.css";

function Stats() {
  const statsData = [
    { number: 9000, label: "Projects Completed" },
    { number: 6000, label: "Clients" },
    { number: 10, label: "Engineers" },
    { number: 5, label: "Awards" },
  ];

  const [stats, setStats] = useState(
    statsData.map(() => ({ number: 0, label: "", completed: false }))
  );

  const statsRef = useRef(null); // Reference for the stats section

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startCounting();
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, []);

  const startCounting = () => {
    const intervals = statsData.map((stat, index) => {
      let count = 0;
      const step = Math.max(1, Math.ceil(stat.number / 100));

      return setInterval(() => {
        count += step;
        if (count >= stat.number) {
          count = stat.number;
          clearInterval(intervals[index]);
        }
        setStats((prevStats) =>
          prevStats.map((item, i) =>
            i === index
              ? { ...item, number: count, label: stat.label, completed: count === stat.number }
              : item
          )
        );
      }, 30);
    });

    return () => intervals.forEach(clearInterval);
  };

  return (
    <section className="stats-section" ref={statsRef}>
      <Container fluid>
        <Row className="text-center">
          {stats.map((stat, index) => (
            <Col md={3} key={index} className="stat-item">
              <div className="stat-number">
                {stat.number.toLocaleString()}
                {stat.completed && "+"}
              </div>
              <div className="stat-label">{stat.label}</div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Stats;
